var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{staticClass:"pdf_manual",attrs:{"max-width":"900","height":"100vh"},model:{value:(_vm.viewDocument),callback:function ($$v) {_vm.viewDocument=$$v},expression:"viewDocument"}},[_c('v-card',{attrs:{"height":"100vh"}},[_c('vue-pdf-app',{attrs:{"file":_vm.pdf}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }